import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HelpersService } from '../../services/tools/helpers.service';
import { GastosService } from '../../services/gastos.service';
import { DatesHelpersService } from '../../services/tools/dates-helpers.service';
import { SucursalesService } from '../../services/sucursales.service';
import { CategoriasGastosService } from '../../services/categorias-gastos.service';
import { Location } from '@angular/common';
import { SubcategoriasGastosService } from '../../services/subcategorias-gastos.service';
import { DeleteGastoComponent } from '../dialogs/delete-gasto/delete-gasto.component'
import {MatDialog, MatPaginator, MatTableDataSource} from '@angular/material';
import { UpdateGastoComponent } from '../dialogs/update-gasto/update-gasto.component';
//PDF
import * as _html2canvas from "html2canvas";
const html2canvas: any = _html2canvas;
declare const require: any;
require('jspdf-autotable');
//import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
declare var $;

@Component({
  selector: 'app-gastos-detallados-mes',
  templateUrl: './gastos-detallados-mes.component.html',
  styleUrls: ['./gastos-detallados-mes.component.scss']
})

export class GastosDetalladosMesComponent implements OnInit {
  // @ViewChild('modalGastos') public modalGastos: GastosModalComponent;
  displayedColumns = ['fecha', 'forma_pago', 'descripcion_gasto', 'nombre_categoria', 'nombre_subcategoria', 'monto_gasto', 'acciones'];
  dataSource = new MatTableDataSource<Datos>(ELEMENT_DATA);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  /**
   * Set the paginator after the view init since this component will
   * be able to query its view for the initialized paginator.
   */
  ngAfterViewInit() {
    setTimeout(() => {this.dataSource.paginator = this.paginator},500);
    this.dataSource.paginator = this.paginator;
    //Modificar etiquetas del paginador a español
    this.paginator._intl.itemsPerPageLabel = 'Registros por página';
    this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 / ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
    this.paginator._intl.firstPageLabel = 'Primera página';
    this.paginator._intl.lastPageLabel = 'Última página';
    this.paginator._intl.previousPageLabel = 'Página anterior';
    this.paginator._intl.nextPageLabel = 'Página siguiente';
    //console.log("Paginator: ", this.paginator);
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  public : any [] = [];
  public isLoading: boolean = false;
  //Paginate 
  public searchText: string = '';
  public object:any[];
  public selected:any;
  public searchProcess:any;
  public searchSelected: any = {};
  public processing:any = false;
  public errors:any = {};

  public fechaInicio: string = null;
  public fechaFin: string = null;
  public sucursales: any[] = [];
  public sucursal: any = {id:null};
  public sucursalPorDefecto: string = "";
  public gastosDetallado : any[];
  public gastos : any[];
  public categoria : any;
  public subcategoria : any;
  public mesURL: string;
  public gastosPorMes : any[];
  public formaPago: string;
  public icono: string;
  public colorGasto: string;
  public imprimirPDF: boolean = false;
  public dataTemp: any[] = [];
  //Variable para obtener la sumatoria del monto de gastos
  public totalListaGastos: number = 0;
  
  //public dataSource:MatTableDataSource<Element>;
  alterTable:any = 'starting';

  tipo : string = "";

  paginate:any = {};
  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;
  currentPage = 1;
  lastPage = 1;
  constructor(
    private helperService : HelpersService,
    private service : GastosService,
    private categoriasService : CategoriasGastosService,
    private subcategoriasService : SubcategoriasGastosService,
    private sucursalesService : SucursalesService,
    private datesHelper : DatesHelpersService,
    private router : Router,
    private activatedRoute : ActivatedRoute,
    private location : Location,
    private dialog: MatDialog
    //private rutaActiva: ActivatedRoute
  ) { }

  ngOnInit() {
    let defaultDates = this.datesHelper.getMonthDate();
    this.fechaInicio = defaultDates.fechaInicio;
    this.fechaFin = defaultDates.fechaFin;

    this.categoria = this.categoriasService.getDefaultSchedule();
    this.subcategoria = this.subcategoriasService.getDefaultSchedule();
    //this.rutaActiva.snapshot.params.mes;
    this.mesURL = this.activatedRoute.snapshot.params.mes;
    console.log("Valor: ", this.activatedRoute.snapshot.params.mes);
    this.mesURL = this.mesURL.toUpperCase();
    this.sucursal={id:this.activatedRoute.snapshot.params.idSucursal};
    console.log("Valor sucursal: ", this.sucursal.id);
    this.getGastosDetallado();
    //console.log("Paginator: ",this.paginator);
    //this.getSucursales();
    //this.paginator._intl.itemsPerPageLabel = 'items por pagina';
    //setTimeout(() => {this.dataSource.paginator = this.paginator},100);
  }

  public formaPagoTexto(opc: number){
    switch(opc){
      case 1: return "Efectivo";
      case 2: return "Transferencia";
      case 3: return "Cheque";
      case 4: return "Tarjeta bancaria";
    }
  }

  public getGastosDetallado(){
    var mesDetalleGastos = this.nameMesToNumber(this.mesURL.split(" ")[0]);
    console.log("Mes Detalle: ",mesDetalleGastos);
    var yearDetalleGastos = this.mesURL.split(" ")[1];
    console.log("Año Detalle: ",yearDetalleGastos);
    var fechaInicial = (yearDetalleGastos+"-"+mesDetalleGastos+"-"+1);
    var fechaFinal = (yearDetalleGastos+"-"+mesDetalleGastos+"-"+31);
    console.log("FInicial: ",fechaInicial);
    let filters = {
      "start-date": fechaInicial,
      "end-date": fechaFinal
    }
    if (this.sucursal.id) {
      filters["idSucursales"] = this.sucursal.id;
    }
    //this.isLoading = true;
    
    this.service.getDetalleGastosMes(filters).subscribe(
      (response)=>
      {
        ELEMENT_DATA.length=0;
        //Aqui está el arreglo de categorias con los datos
        const jsonResult = response.json().content;
        this.gastos = jsonResult;
        console.log("Array gastos ",this.gastos);
        this.totalListaGastos = 0;
        this.gastos.forEach(gasto => {
          this.formaPago = this.formaPagoTexto(gasto.forma);
          this.icono = gasto.icono;
          this.colorGasto = gasto.color;
          ELEMENT_DATA.push({ fecha: gasto.fecha, forma_pago: this.formaPago, descripcion_gasto: gasto.descripcion, nombre_categoria: gasto.nombre_cat, nombre_subcategoria: gasto.nombre_sub, monto_gasto: gasto.monto, color_gasto: this.colorGasto, icono_gasto: this.icono, idGasto: gasto.id});
          this.totalListaGastos = (this.totalListaGastos + gasto.monto);
          var fechaTemp = gasto.fecha.split(" ");
          var formatoMontoGasto = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(gasto.monto);
          this.dataTemp.push([fechaTemp[0], this.formaPago, gasto.descripcion, gasto.nombre_cat, gasto.nombre_sub, formatoMontoGasto]);
        });
        var formatoTotalGastos = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD', minimumFractionDigits: 2}).format(this.totalListaGastos);
        this.dataTemp.push(["", "", "", "", "Total",formatoTotalGastos]);
        //ELEMENT_DATA = datosTemp;
        //Datos para PDF
        // this.dataTemp = ELEMENT_DATA;
        //Verificar datos
        console.log("Data: ",ELEMENT_DATA);
        console.log("DataTemp: ",this.dataTemp);
        console.log("Total gastos: ", this.totalListaGastos);
        //this.isLoading = false;
      }, error => 
      {
        //this.isLoading = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public printPDF(){
    this.downloadPDF(this.dataTemp);
  }

  public postDataArray(): any[]{
    return this.dataTemp;
  }

  //Función para crear PDF
  public downloadPDF(bodyTable: any []) {
    var doc = new jsPDF();
    doc.setFontStyle("bold");
    doc.setFontSize(15);
    doc.text(15, 20, 'PROFINMEX');
    doc.setFontSize(13);
    doc.text(15, 30, 'Reporte detallado de '+this.mesURL.toLowerCase());
    //Dar formato pesos mexicanos
    var sumaTotal = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'MXN', minimumFractionDigits: 2}).format(this.totalListaGastos);
    doc.text(15, 40, 'Total de gastos: '+sumaTotal);
    //doc.addPage();
    doc.autoTable({
      margin: { top: 45 },
      head: [["Fecha", "Forma de pago", "Descripción", "Categoría", "Subcategoría", "Monto"]],
      body: bodyTable,
      willDrawCell: function(data) {
        var doc = data.doc;
        var rows = data.table.body;
        if (rows.length === 1) {
        } else if (data.row.index === rows.length - 1) {
          doc.setFontStyle("bold");
          doc.setFontSize("11");
          doc.setFillColor(255, 255, 255);
        }
      },
    });
    doc.save("Reporte_"+this.mesURL.trim());
    
  }
  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.getGastosDetallado();
          this.isLoading = false;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  public nameMesToNumber(nombreMes: string){
    switch (nombreMes.toLowerCase()){
      case "enero": return 1;
      case "febrero": return 2; 
      case "marzo": return 3;  
      case "abril": return 4; 
      case "mayo": return 5; 
      case "junio": return 6; 
      case "julio": return 7; 
      case "agosto": return 8; 
      case "septiembre": return 9; 
      case "octubre": return 10; 
      case "noviembre": return 11;
      case "diciembre": return 12;
    }
  }
  getSubcategoria(id : number){
    console.log(id)
    this.subcategoriasService.find(id).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        this.subcategoria = jsonResult.content;
        this.getSucursales();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  back(){
    this.location.back();
  }

  sucursalChanged(sucursal){
    if(sucursal){
        this.sucursal = sucursal;
        this.getGastosDetallado();
    }
  }
  
  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  //Update
  public actualizarGasto(id: number){
    const dialogRef = this.dialog.open(UpdateGastoComponent, {
      height: '80vh',
      width: '25vw',
      data: {idGasto: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.update){
        window.location.reload();
      }
    });
  }

  //Delete gasto
  public eliminarGasto(id: number){
    const dialogRef = this.dialog.open(DeleteGastoComponent, {
      height: '200px',
      width: '250px',
      data: {idGasto: id}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.eliminar){
        window.location.reload();
      }
    });
  }

  
  //Alternatibva para guardar pdf pero renderiza el html
  // public downloadPDF() {
  //   // Extraemos el
  //   const DATA = document.getElementById('htmlData');
  //   const jsPDF = require('jspdf')
  //   const doc = new jsPDF('p', 'pt', 'a4');
  //   const options = {
  //     background: 'white',
  //     scale: 3
  //   };
  //   html2canvas(DATA, options).then((canvas) => {

  //     const img = canvas.toDataURL('image/png');
  //     // Add image Canvas to PDF
  //     const bufferX = 15;
  //     const bufferY = 15;
  //     const imgProps = (doc as any).getImageProperties(img);
  //     const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
  //     return doc;
  //   }).then((docResult) => {
  //     docResult.save("Reporte_"+this.mesURL);
  //   });
  // }
}

export interface Datos {
  fecha: string;
  forma_pago: string;
  descripcion_gasto: string;
  nombre_categoria: string;
  nombre_subcategoria: string;
  monto_gasto: number;
  color_gasto: string;
  icono_gasto: string;
  idGasto: number;
}
const ELEMENT_DATA: Datos[] = [];



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-detallados-mes/gastos-detallados-mes.component.ts